import { useEffect, useState } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { enableListDetailBanners } from '@Components/Utilities/SandhillsConstants';
import { approvalAmountLocalStorageName } from '@Components/Utilities/SandhillsConstants';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import atoms from '@Components/Utilities/SandhillsAtoms';
import translator from '@Components/Utilities/Translator';

const LoanApprovalEstimateBanner = (props) => {

    const setShowLaeModal = useSetRecoilState(atoms.showLae);
    const [lae, setLae] = useRecoilState(atoms.lae);

    const onClick = () => {
        if (!props.isFinCalc) {
            document.getElementsByTagName('body')?.[0]?.classList?.add('lock');
            setShowLaeModal(true);
        } else {
            let modal = document.getElementsByClassName('calculator-form')?.[0];
            let slidePower = document.getElementsByClassName('slide-power')?.[0];
            let overlay = document.getElementsByClassName('overlay')?.[0];
            overlay?.classList?.toggle('block');
            modal?.classList?.toggle('lock');
            slidePower?.classList?.toggle('slideIn');
        }
    };

    useEffect(() => {
        if (!lae) {
            let loanApprovalEstimate = localStorage.getItem(approvalAmountLocalStorageName);
            if (loanApprovalEstimate) {
                setLae(loanApprovalEstimate);
            }
        }
    }, []);

    return (enableListDetailBanners &&
        <div className={'currency-banner currency-banner-' + props.pageType}>
            {!lae &&
                <LazyLoadComponent>
                    <div className='currency-text currency-estimate-not-completed currency-background'>
                        <div className='currency-text'>
                            Buy what you want <span>with</span> <img src={props.LogoUrlWhite} alt='Currency Finance Logo' />
                        </div>
                        <div className={'currency-image currency-image-' + props.pageType}>
                            {!props.pageType == 'list' &&
                                <div>
                                    <img src={props.EquipmentImageUrl} alt='Buy With Currency' loading='lazy'/>
                                </div>
                            }
                        </div>
                        <div className={'currency-apply currency-apply-' + props.pageType}>
                            <p role="button" tabIndex="0" className='currency-btn gtm-loan-approval-estimate-banner-get-loan-amount' onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } }}>{translator.translate('sandhills.checkbuyingpower')}</p>
                        </div>
                    </div>
                </LazyLoadComponent>}
            {lae &&
                <LazyLoadComponent>
                    <div className='currency-estimate-completed currency-background'>
                        <div className='currency-circle'>
                            <img src={props.IconUrl} alt='Currency Finance Icon' />
                        </div>
                        <div className='currency-text'>
                            {translator.translate('sandhills.estimatedbuyingpower')} <strong><span className='loan-approval-amount'>{lae}</span></strong>
                        </div>
                        <div className='currency-logo'>
                            <img src={props.LogoUrlWhite} alt='Currency Finance Logo' />
                        </div>
                        <div className='currency-apply'>
                            <a className='fund-btn gtm-loan-approval-estimate-banner-get-funded' href={props.LenderUrl ?? props.FinancingURL} target='_blank' aria-label={"Apply Now (" + translator.translate('sandhills.opensinanewtab') + ")"}>{translator.translate('sandhills.tradesites.mvc.applynow').toLowerCase()}<span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span></a>
                        </div>
                        <div className='currency-recalculate'>
                            <a className='recalc-btn gtm-loan-approval-estimate-banner-recalculate' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); onClick(); } }} onClick={onClick}>{translator.translate('sandhills.recalculate')}</a>
                        </div>
                    </div>
                </LazyLoadComponent>}
        </div>
    );
};

export default LoanApprovalEstimateBanner;